module.exports = __webpack_public_path__ + "static/media/oblongeia.9acf26cc.png";